import { type FC, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import avtar from '../../../Assets/avtar.png'
import { DataContext } from '../../../Context/DataProvider';
import Profile from '../Profile/Profile';
import { FaPlus } from 'react-icons/fa';

interface TopNavProps { }
const TopNav: FC<TopNavProps> = () => {
  const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  const { pathname } = useLocation();
  const pageTitle = pathname?.split('/')?.[2]?.charAt(0)?.toUpperCase() + pathname?.split('/')?.[2]?.slice(1)
  // const navigate = useNavigate()
  const { profileToggle, setProfileToggle, setOpenForm, openFotm } = useContext(DataContext)

  return (
    <div className='w-full h-full bg-skin-bg-topNav flex items-center justify-between sm:px-4 p-2'>
      <p className='text-lg font-medium transition-all duration-300 text-skin-topNav-secondery-text cursor-default'>{pageTitle}</p>
      <div className='flex items-center gap-2 h-full py-2'>
        <div onClick={() => setOpenForm(!openFotm)} title='Add Transaction' className='w-6 h-6 rounded-full cursor-pointer border border-skin-border flex justify-center items-center text-skin-topNav-text'>
          <FaPlus />
        </div>
        <div className='w-[1px] h-full border-l-2 border-skin-border'></div>
        <div title={userDetails.name} className='w-[50px] truncate cursor-default text-sm font-semibold text-skin-topNav-secondery-text'>{userDetails.name}</div>
        <div onClick={() => setProfileToggle(!profileToggle)} title='Profile' className='cursor-pointer w-10 h-10 rounded-full border-2 border-skin-border'><img className='w-full h-full rounded-full p-[2px]' src={avtar} alt="" />
        </div>
        <Profile />
      </div>
    </div>
  );
}

export default TopNav;
